// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartDocumentQuestionStreamMutationVariables = Types.Exact<{
  input: Types.AskDocumentQuestionInput;
}>;


export type StartDocumentQuestionStreamMutation = { __typename?: 'Mutation', startDocumentQuestionStream: { __typename?: 'StartDocumentQuestionStreamPayload', workflowTracker: { __typename?: 'WorkflowTracker', id: string }, conversation: { __typename?: 'Conversation', id: string } } };

export const Operations = {
  Mutation: {
    StartDocumentQuestionStream: 'StartDocumentQuestionStream' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const StartDocumentQuestionStreamDocument = gql`
    mutation StartDocumentQuestionStream($input: AskDocumentQuestionInput!) {
  startDocumentQuestionStream(input: $input) {
    workflowTracker {
      id
    }
    conversation {
      id
    }
  }
}
    `;
export type StartDocumentQuestionStreamMutationFn = Apollo.MutationFunction<StartDocumentQuestionStreamMutation, StartDocumentQuestionStreamMutationVariables>;

/**
 * __useStartDocumentQuestionStreamMutation__
 *
 * To run a mutation, you first call `useStartDocumentQuestionStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDocumentQuestionStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDocumentQuestionStreamMutation, { data, loading, error }] = useStartDocumentQuestionStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartDocumentQuestionStreamMutation(baseOptions?: Apollo.MutationHookOptions<StartDocumentQuestionStreamMutation, StartDocumentQuestionStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDocumentQuestionStreamMutation, StartDocumentQuestionStreamMutationVariables>(StartDocumentQuestionStreamDocument, options);
      }
export type StartDocumentQuestionStreamMutationHookResult = ReturnType<typeof useStartDocumentQuestionStreamMutation>;
export type StartDocumentQuestionStreamMutationResult = Apollo.MutationResult<StartDocumentQuestionStreamMutation>;
export type StartDocumentQuestionStreamMutationOptions = Apollo.BaseMutationOptions<StartDocumentQuestionStreamMutation, StartDocumentQuestionStreamMutationVariables>;